module.exports = __webpack_public_path__ + "img/thumbnail_Llama_m_albino.d9a0a866.png";